import { AppModule } from 'app/module';
import { mediaQueries } from 'util/mediaQueries';
import Template from './template.hbs';
import './styles.scss';

export class EbAccordion extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            items: ['.m-ebAccordion__item'],
            desktopImage: ['.m-ebAccordion__desktopImg'],
            content: ['.m-ebAccordion__content'],
        };
    }

    ready() {
        this.initializeAccordion();
    }

    domEvents() {
        if (this.dom.items) {
            this.active = 0;
            for (let i = 0; i < this.dom.items.length; i += 1) {
                this.dom.items[i].addEventListener('click', () => this.toggleAccordion(i));
            }
        }
    }

    toggleAccordion(index) {
        if (index === this.active) return; // No action if the same item is clicked
        this.updateAriaAttributes(index);
        this.animateCollapse(this.active);
        this.animateExpand(index);
        this.active = index;
    }

    updateAriaAttributes(index) {
        // Collapse previous item and desktop image
        this.dom.items[this.active].setAttribute('aria-expanded', 'false');
        this.dom.desktopImage[this.active].setAttribute('aria-expanded', 'false');

        // Expand clicked item and desktop image
        this.dom.items[index].setAttribute('aria-expanded', 'true');
        this.dom.desktopImage[index].setAttribute('aria-expanded', 'true');
    }

    animateCollapse(index) {
        const box = this.dom.content[index];
        if (!box.style) return;
        box.style.height = '0px';
    }

    animateExpand(index) {
        const box = this.dom.content[index];
        box.style.height = `${box.scrollHeight}px`;
    }

    initializeAccordion() {
        this.dom.items[0].setAttribute('aria-expanded', 'true');
        this.dom.desktopImage[0].setAttribute('aria-expanded', 'true');
        if (mediaQueries.isMobile()) {
            this.dom.content[0].style.height = '482px';
        }
        this.animateCollapse(1);
        this.animateCollapse(2);
    }
}
